module.exports = __webpack_public_path__ + "img/magnet-icon.f43562bb.svg";